import React from 'react'
import flowRight from 'lodash/flowRight'

import { LKButton as LKBaseButton } from 'loankeeper-common/components'
import LKModal, { LKModalContainer, LKModalTrigger } from 'shared/LKModal'

import AddForm from './AddForm'

import { MODAL_NAME } from './constants'
import translate from './translate'

import container from './container'

const ClientRiskLevelModal = ({ modalInstanceName, submit, submitting, ID, hash, linkedfiles, params }) => (
  <LKModal
    icon="add"
    name={modalInstanceName}
    heading={translate('frm_client_risklevel_add_edit')}
    size="sm-1"
    footer={
      <LKModal.Footer>
        {params && params.type === 'details' ? null : (
          <LKBaseButton.Okay onClick={submit} disabled={submitting} loading={submitting} />
        )}
      </LKModal.Footer>
    }
  >
    <AddForm ID={ID} hash={hash} linkedfiles={linkedfiles} params={params} />
  </LKModal>
)

export const ClientRiskLevelModalTrigger = ({ children, disabled }) => (
  <LKModalTrigger disabled={disabled} name={MODAL_NAME} alias="add">
    {children}
  </LKModalTrigger>
)

const enhance = flowRight(LKModalContainer(MODAL_NAME), container)

export default enhance(ClientRiskLevelModal)
